import React from 'react';
import styles from "../styles/changePassword.module.css";

const ChangePassword = () => {
  return (
    <div className={styles.changeWrapper} >
        <p className={styles.heading}>Change your password</p>
        <div className={styles.formWrapper}>
        <form action="">
            <label htmlFor="CurrentPassword">Current password</label>
            <input type="password" name="" id="" />

            <label htmlFor="NewPassword">New password</label>
            <input type="password" name="" id="" />

            <label htmlFor="ConfirmPassword">Confrim password</label>
            <input type="password" name="" id="" />
            
            <button type="submit" className={styles.sbmt}>Save profile</button>
        </form>
        </div>
    </div>
  )
}

export default ChangePassword